import { memo } from 'react';

import { CollapseWorkspacePanelButton } from '~/components/v2/components/shared/panel/CollapseWorkspacePanelButton';

/** Workspace collapse control for non-board page headers in canvas split layout. */
export const WorkspacePanelCollapseSlot = memo(() => <CollapseWorkspacePanelButton panelContext="workspace" />);

WorkspacePanelCollapseSlot.displayName = 'WorkspacePanelCollapseSlot';
